
import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { ContextCollection } from "../../../contexts/DependencyContext";
import { ConfigurationApiClient } from "../clients/ConfigurationApiClient";
import { IComponent } from "./models/IComponent";
import { IComponentInfoResult } from "./models/IComponentInfoResult";
import { IGetComponentFamilyByIdsParameters } from "./models/IGetComponentFamilyByIdsParameters";
import { IGetComponentFamilyByCodesParameters } from "./models/IGetComponentFamilyByCodesParameters";
import { IGetComponentFamilyByKeywordsParameters } from "./models/IGetComponentFamilyByKeywordsParameters";
import { ISearchComponentsPaginatedResult } from "./models/ISearchComponentsPaginatedResult";
import { ISearchComponentsPaginatedParameters } from "./models/ISearchComponentsPaginatedParameters";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class ComponentService
{
	private readonly url: string;

	constructor(private readonly apiClient: ConfigurationApiClient)
    {
        this.url = "component";
    }

    async getById(id: number): Promise<IComponent>
    {
        return await this.apiClient.get<IComponent>(`${this.url}/${id}`);
    }

    async getAllForCompany(id: number): Promise<IComponent[]>
    {
        return await this.apiClient.get<IComponent[]>(`${this.url}/company/${id}`);
    }

    async getRoots(): Promise<IComponent[]>
    {
        return await this.apiClient.get<IComponent[]>(`${this.url}/roots`);
    }

    async getChildren(id: number): Promise<IComponent[]>
    {
        return await this.apiClient.get<IComponent[]>(`${this.url}/children/${id}`);
    }

    async getParents(id: number): Promise<IComponent[]>
    {
        return await this.apiClient.get<IComponent[]>(`${this.url}/parents/${id}`);
    }

    async getInfo(id: string): Promise<IComponentInfoResult>
    {
        return await this.apiClient.get<IComponentInfoResult>(`${this.url}/info/${id}`);
    }

    async getByCompanyAndTypes(companyId: number, types: number[]): Promise<IComponent[]>
    {
        return await this.apiClient.post<IComponent[]>(`${this.url}/company/${companyId}/bytypes`);
    }

    async getComponentFamilyByIds(parameters: IGetComponentFamilyByIdsParameters): Promise<IComponent[]>
    {
        return await this.apiClient.post<IComponent[]>(`${this.url}/ids`,{},JSON.stringify(parameters));
    }

    async getComponentFamilyByCodes(parameters: IGetComponentFamilyByCodesParameters): Promise<IComponent[]>
    {
        return await this.apiClient.post<IComponent[]>(`${this.url}/codes`,{},JSON.stringify(parameters));
    }

    async getComponentFamilyByKeywords(parameters: IGetComponentFamilyByKeywordsParameters): Promise<IComponent[]>
    {
        return await this.apiClient.post<IComponent[]>(`${this.url}/keywords`,{},JSON.stringify(parameters));
    }

    async search(parameters: ISearchComponentsPaginatedParameters): Promise<ISearchComponentsPaginatedResult>
    {
        return await this.apiClient.post<ISearchComponentsPaginatedResult>(`${this.url}/search`,{},JSON.stringify(parameters));
    }

    async getComponentsWithCoordinates(): Promise<IComponent[]>
    {
        return await this.apiClient.get<IComponent[]>(`${this.url}/withcoordinates`);
    }
}
